// utils/dateRange.ts
import { getSystemLocalDate } from "../DateFilterBar";

export type RangePreset = "Today" | "Yesterday" | "LastWeek" | "LastMonth" | "180days" | "CustomizeDate";

export interface DateRange {
  startDate: string;
  endDate: string;
}

const shiftDays = (baseDate: Date, days: number): Date => {
  const date = new Date(baseDate);
  date.setDate(date.getDate() - days);
  return date;
};

// Preset offsets relative to today
const PRESET_OFFSETS: Record<Exclude<RangePreset, "CustomizeDate">, { startDays: number; endDays: number }> = {
  Today: { startDays: 0, endDays: 0 },
  Yesterday: { startDays: 1, endDays: 1 },
  LastWeek: { startDays: 6, endDays: 0 },
  LastMonth: { startDays: 29, endDays: 0 },
  "180days": { startDays: 179, endDays: 0 },
};

/** Returns { startDate, endDate } formatted YYYY-MM-DD for a preset. Returns null for CustomizeDate. */
export const getPresetRange = (preset: RangePreset): DateRange | null => {
  if (preset === "CustomizeDate" || !PRESET_OFFSETS[preset]) {
    return null;
  }

  const now = new Date();
  const { startDays, endDays } = PRESET_OFFSETS[preset];

  const startDate = getSystemLocalDate(shiftDays(now, startDays));
  const endDate = endDays === 0 ? getSystemLocalDate(now) : getSystemLocalDate(shiftDays(now, endDays));

  return { startDate, endDate };
};
